module.exports = __webpack_public_path__ + "img/6.6f26c8b1.png";